module.exports = __webpack_public_path__ + "img/9badb67e921460378889d0398d1e39de.dcdae214.png";